import React from "react";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import styled from "styled-components";

interface Props {
    tagKey: string;
    className?: string;
    readOnlyMode?: boolean;
    disableRemove?: boolean;
    onTagClickCallback?: (tagKey: string) => void;
    onRemoveTagCallback?: (tagKey: string) => void;
}

const Tag: React.FC<Props> = ({
    tagKey,
    className,
    readOnlyMode,
    disableRemove,
    onTagClickCallback,
    onRemoveTagCallback,
}) => {
    return (
        <Container
            className={className}
            readOnlyMode={readOnlyMode}
            key={tagKey}
            onClick={() => onTagClickCallback && onTagClickCallback(tagKey)}
        >
            <span>{tagKey}</span>
            {!readOnlyMode && !disableRemove ? (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!readOnlyMode && onRemoveTagCallback)
                            onRemoveTagCallback(tagKey);
                    }}
                >
                    <IoMdRemoveCircleOutline />
                </button>
            ) : null}
        </Container>
    );
};

const Container = styled.div<{ readOnlyMode?: boolean }>`
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.colors.primary[400]};
    color: white;
    height: min-content;
    width: min-content;
    margin: 2px;
    padding: 0.125rem 0.5rem;
    border-radius: 0.2rem;

    &:hover {
        cursor: pointer;
    }

    & > *:first-child {
        white-space: nowrap;
        user-select: none;
    }

    & > *:last-child {
        color: ${(props) => props.theme.colors.neutral[100]};
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover > * {
            fill: ${(props) => props.theme.colors.danger[300]};
        }
    }
`;

export default Tag;
